import { isArray } from 'util';
import { toJS } from 'mobx';
import getDataPoint from './getDataPoint';
import { translate } from '../Components/Translate';
import performanceCheck from '../utils/performanceCheck';
import { ShareClass } from '../models/entity';
import { DataLocator } from '../models/configuration/DataLocator';

import GetColumnValueOptions from '../models/utils/GetColumnValueOptions';
import { DataStore, SuperscriptScope, ConfigStore } from '../stores';

export function getColumnValue(options: GetColumnValueOptions) {
    const {
        config,
        column,
        shareClass,
        locale,
        fundCurrency,
        defaultNoDataPlaceholder,
        translationStore,
        dataStore,
    } = options;
    const { property, data, cellDisclaimers } = column;
    let response: string = '';
    if (isArray(toJS(data))) {
        response = (data as Array<DataLocator>)
            .map(d => {
                return (
                    translate(
                        translationStore,
                        getDataPoint({
                            dataStore,
                            shareClass,
                            locale,
                            fundCurrency,
                            defaultNoDataPlaceholder,
                            dataConfig: d as any,
                            hasPerformance: hasPerformance(
                                dataStore,
                                d.performanceCheck,
                                config,
                                shareClass
                            ),
                        })
                    ) + (d.separator || '')
                );
            })
            .join('');
    } else if (data) {
        response = translate(
            translationStore,
            getDataPoint({
                dataStore,
                shareClass,
                locale,
                fundCurrency,
                defaultNoDataPlaceholder,
                dataConfig: (data as any) as DataLocator,
                hasPerformance: hasPerformance(
                    dataStore,
                    (data as DataLocator).performanceCheck,
                    config,
                    shareClass
                ),
            })
        );
    }

    // Support simple label/property column definition
    else if (property) {
        response = translate(
            translationStore,
            getDataPoint({
                dataStore,
                shareClass,
                locale,
                fundCurrency,
                defaultNoDataPlaceholder,
                dataConfig: {
                    property: 'properties_pub',
                    code: property,
                    key: 'value',
                },
                hasPerformance: true,
            })
        );
    } else {
        response = defaultNoDataPlaceholder.toString();
    }

    if (cellDisclaimers && dataStore && dataStore.disclaimerStore) {
        const superscripts = dataStore.disclaimerStore.getSuperscripts(
            shareClass,
            cellDisclaimers,
            SuperscriptScope.module
        );
        if (superscripts && superscripts.length > 0) {
            response += ` - (${superscripts.join(', ')})`;
        }
    }

    return response;
}

function hasPerformance(
    dataStore: DataStore,
    mustCheckPerformance: boolean,
    config: ConfigStore,
    shareClass: ShareClass
) {
    if (mustCheckPerformance) {
        return performanceCheck({
            dataStore,
            config,
            shareClass,
        });
    }
    return true;
}



// WEBPACK FOOTER //
// ./src/utils/getColumnValue.ts